import { IReportRequest, IReportResponse } from "src/models";
import { createAction, createAsyncAction } from "typesafe-actions";

export const reset = createAction('RESET')<void>();
export const getJobReport = createAsyncAction(
    "scan/INITIATE_GET_JOB_REPORT_REQUEST",
    "scan/INITIATE_GET_JOB_REPORT_SUCCESS",
    "scan/INITIATE_GET_JOB_REPORT_FAILURE"
)<IReportRequest, IReportResponse, Error>();